"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("core.ui-module_site-components");
var _dateFns = require("date-fns");
var _SecureClient = require("../../api/SecureClient");
var _ApplicationContext = require("../../api/ApplicationContext");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
class RemoteFileBrowser extends _react.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      files: [],
      errorMessage: null
    };
  }
  componentDidMount() {
    const secureClient = new _SecureClient.SecureClient();
    secureClient.get('/infrastructure/file-system/walk?startPath=/').then(response => {
      const {
        data
      } = response;
      const files = [];
      this.convertFiles(files, data.children);
      this.setState({
        errorMessage: null,
        isLoading: false,
        files
      });
    }).catch(() => {
      this.setState({
        errorMessage: 'Unable to read the remote directory',
        isLoading: false
      });
    });
  }
  convertFiles(files, children) {
    for (let i = 0; i < children.length; i += 1) {
      const child = children[i];
      if (child.directory) {
        this.convertFiles(files, child.children);
      } else {
        const file = {
          key: child.path,
          modified: +(0, _dateFns.parseJSON)(child.lastModified),
          size: child.size
        };
        files.push(file);
      }
    }
  }
  downloadFile(file) {
    const secureClient = new _SecureClient.SecureClient();
    let fileName = String(file);
    fileName = fileName.substring(fileName.lastIndexOf('/') + 1);
    secureClient.get(`/infrastructure/file-system/get-download-token?filePath=/${file}`).then(response => {
      const link = document.createElement('a');
      link.href = `${_ApplicationContext.ApplicationContext.getApiBasePath()}/infrastructure/file-system/get-by-token?tokenId=${response.data}`;
      link.setAttribute('download', fileName);
      link.click();
    }).catch(() => {
      this.setState({
        errorMessage: 'Unable to download the specified file',
        isLoading: false
      });
    });
  }
  render() {
    const {
      isLoading,
      files
    } = this.state;
    let message = /*#__PURE__*/_react.default.createElement(_react.Fragment, null);
    if (isLoading) {
      message = /*#__PURE__*/_react.default.createElement(_core.Spinner, null);
    } else {
      message = /*#__PURE__*/_react.default.createElement(_core.RcFileBrowser, {
        files: files,
        onDownloadFile: file => this.downloadFile(file)
      });
    }
    return /*#__PURE__*/_react.default.createElement(_core.Box, {
      hasBorder: true
    }, message);
  }
}
exports.default = RemoteFileBrowser;
//# sourceMappingURL=RemoteFileBrowser.js.map